import { Container as MuiContainer, ContainerProps } from '@mui/material';

const Container = ({ ...rest }: ContainerProps) => <MuiContainer {...rest} />;

export default Container;
